import { useState } from "react";
import emailjs from "@emailjs/browser";

interface Props {
  open: boolean;
  onClose: () => void;
}

const DiagnosticFormModal = ({ open, onClose }: Props) => {
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    nombre: "",
    empresa: "",
    cargo: "",
    correo: "",
    telefono: ""
  });

  if (!open) return null;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      await emailjs.send(
        "service_xxftmof",
        "template_q3cxntf",
        {
          name: "Diagnóstico SERGEN",
          email: form.correo,
          message: `
Nuevo diagnóstico SERGEN

Nombre: ${form.nombre}
Empresa: ${form.empresa}
Cargo: ${form.cargo}
Correo: ${form.correo}
Teléfono: ${form.telefono}
          `
        },
        "zPFsGWM__hwjs2vAc"
      );

      // =====================================
      // ✅ CONVERSIÓN GOOGLE ADS (ROBUSTA)
      // =====================================
      if (typeof window !== "undefined") {
        const w = window as any;

        if (w.gtag) {
          w.gtag("event", "conversion", {
            send_to: "AW-17761399504/ZmcbCP_ApN8bENDlpZVC"
          });
        } else {
          w.dataLayer = w.dataLayer || [];
          w.dataLayer.push({
            event: "conversion",
            send_to: "AW-17761399504/ZmcbCP_ApN8bENDlpZVC"
          });
        }
      }

      alert("Información enviada correctamente.");
      onClose();

    } catch (error) {
      console.error("EmailJS error:", error);
      alert("Ocurrió un error al enviar la información.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center px-4">
      <div className="bg-white w-full max-w-lg rounded-2xl p-8 relative">

        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-xl text-gray-400"
          aria-label="Cerrar"
        >
          ×
        </button>

        <h3 className="text-2xl font-bold text-center">
          Evaluar factura eléctrica
        </h3>

        <form onSubmit={handleSubmit} className="mt-6 space-y-4">

          <input
            name="nombre"
            placeholder="Nombre"
            required
            onChange={handleChange}
            className="w-full border px-4 py-3 rounded-lg"
          />

          <input
            name="empresa"
            placeholder="Empresa"
            required
            onChange={handleChange}
            className="w-full border px-4 py-3 rounded-lg"
          />

          <input
            name="cargo"
            placeholder="Cargo"
            required
            onChange={handleChange}
            className="w-full border px-4 py-3 rounded-lg"
          />

          <input
            type="email"
            name="correo"
            placeholder="Correo"
            required
            onChange={handleChange}
            className="w-full border px-4 py-3 rounded-lg"
          />

          <input
            name="telefono"
            placeholder="Teléfono"
            required
            onChange={handleChange}
            className="w-full border px-4 py-3 rounded-lg"
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-sergen-500 text-white py-3 rounded-full font-semibold"
          >
            {loading ? "Enviando..." : "Enviar información"}
          </button>

        </form>
      </div>
    </div>
  );
};

export default DiagnosticFormModal;
